var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1173_27994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5533 4.00019C21.4625 3.99082 21.3709 3.99082 21.28 4.00019H2.61334C2.49371 4.00203 2.37486 4.01997 2.26001 4.05352L11.8933 13.6469L21.5533 4.00019Z",
    fill: "#113E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.54 4.92676L12.8333 14.5934C12.5835 14.8418 12.2456 14.9811 11.8933 14.9811C11.5411 14.9811 11.2032 14.8418 10.9533 14.5934L1.33335 5.00009C1.30378 5.10878 1.28809 5.22079 1.28668 5.33342V18.6668C1.28668 19.0204 1.42716 19.3595 1.67721 19.6096C1.92725 19.8596 2.26639 20.0001 2.62002 20.0001H21.2867C21.6403 20.0001 21.9794 19.8596 22.2295 19.6096C22.4795 19.3595 22.62 19.0204 22.62 18.6668V5.33342C22.6147 5.19453 22.5877 5.05731 22.54 4.92676ZM3.53335 18.6668H2.60668V17.7134L7.45335 12.9068L8.39335 13.8468L3.53335 18.6668ZM21.2733 18.6668H20.34L15.48 13.8468L16.42 12.9068L21.2667 17.7134L21.2733 18.6668Z",
    fill: "#113E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_27994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#113E2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/contactEmail.f770acafa480856283afa199f1b0ab23.svg";
export { ForwardRef as ReactComponent };